
<template>
    <div class="qi-cai">
        <div class="qi-cai-top">
            <!-- 背景图 -->
            <div class="bid-inner">
                <div class="bid-title">
                    企业招标采购一体化解决方案
                </div>
                <div class="bid-bg"></div>
            </div>
        </div>

        <div class="qi-cont">
            <div class="qi-cont-top">
                <div class="inner">
                    <p class="title">{{bidText.title}}</p>
                    <p>{{bidText.p1}}</p>
                    <img src="/images/serve/qy-1.png" alt="">
                </div>
            </div>

            <div class="qi-cont-bot">
                <div class="qi-list">
                    <div class="qi-item" v-for="(item , i) in itemData" :key="i">
                        <img :src="item.img" alt="">
                        <div class="qi-p">
                            <p class="title"> {{item.title}}</p>
                            <p class="text">{{item.text}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    name: '',
    components: {},
    data() {
        return {
            bidText: {
                title: '企业招标采购一体化解决方案',
                p1: '以大数据底座为支撑，以采购管理业务为主线的电子招标采购管理平台，是结合招标采购流程，适合招标采购需求，包含公开招标、邀请招标、竞争性谈判、竞争性磋商、询比价采购、竞价采购系统、直接采购等交易模式，为采购需求方、采购执行人、供应商、专家、监管机构提供一体化的交易管理平台，实现采购管理工作的信息化和规范化。助力采购降本、增效、阳光、合规，平台聚量议价赋能行业采购生态。建设“互联网+采购”，与企业内部ERP、OA等系统打通，实现信息互联互通，避免数据重复登记，覆盖计划、执行、合同、履约、支付、资产、监管等全流程公开透明可追溯的采购交易数据闭环管理。',
            },

            itemData: [
                {
                    img: '/images/serve/q-1.png',
                    title: '全能模式轻松采购',
                    text: '支持所有采购形式，可根据项目不同，灵活切换模式',
                },
                {
                    img: '/images/serve/q-2.png',
                    title: '流程管理，进度保障',
                    text: '跨部门协作，打通信息壁垒，统一管理采购进程，关键节点信息推送',
                },
                {
                    img: '/images/serve/q-3.png',
                    title: '降低成本，公开透明',
                    text: '全程线上操作，降低各种人工成本及资源浪费，大幅提升效率。同时系统全程留痕，与监管平台对接，整个过程公开透明。',
                },
                {
                    img: '/images/serve/q-4.png',
                    title: '合同管理和项目验收',
                    text: '帮助企业快速完成合同和归档，避免采购记录的缺失，面临审计时可以快速出具相关报表和精准数字。',
                },
                {
                    img: '/images/serve/q-5.png',
                    title: '数据分析，科学决策',
                    text: '采集并分析相关数据，一键生成智能报告，研判预算执行情况，辅助采购人员科学决策。',
                },
                {
                    img: '/images/serve/q-6.png',
                    title: '无缝对接企业原有管理系统',
                    text: '系统可以与企业已有财务、ERP等软件完美对接，形成管理招采一体化的战略布局。',
                },
                {
                    img: '/images/serve/q-7.png',
                    title: '配套商城搭建',
                    text: '为国企配套搭建招采网站及线上商城，深度管理供应商，由货比三家到货比多家，进一步优化采供协作关系。',
                },
                {
                    img: '/images/serve/q-8.png',
                    title: '模块化定制服务',
                    text: '根据客户的需求定制化服务，可自选模块，灵活组合，无缝链接。',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.qi-cai {
    background-color: #fff;
    width: 100%;
    min-height: 1000px;
    position: relative;
    .qi-cai-top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: #1854FF;
        background-size: 100% 100%;
        background-size: cover;

        .bid-inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            .bid-title {
                width: 600px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bid-bg {
                z-index: 10;
                position: absolute;
                top: 46px;
                right: 20px;
                width: 410px;
                height: 265px;
                background: url('/images/serve/bg.png') no-repeat;
                background-size: 100% 100%;
                background-size: cover;
            }
        }
    }

    .qi-cont {

        .qi-cont-top {
            // height: 240px;
            width: 100%;
            // padding: 30px 40px 40px;
            // box-shadow: 0 0 10px rgb(173, 173, 173);
            background-color: #f6fbfe;
            text-align: center;
            .inner {
                width: 1200px;
                padding: 30px 0;
            }
            p {
                font-size: 15px;
                color: #131415;
                margin: 30px 0;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                color: #131415;
            }
        }

        .qi-cont-bot {
            width: 1200px;
            margin: 0 auto;
            margin-top: 30px;
            padding-bottom: 60px;
            .qi-list {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .qi-item {
                    width: 592px;
                    height: 128px;
                    background-color: #f8f8f9;
                    padding: 24px;
                    margin: 10px 0;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    cursor: pointer;
                    &:hover .qi-p p{
                        color: $primaryColor9;
                    }

                    img {
                        width: 48px;
                        height: 48px;
                        display: inline-block;
                    }
                    .qi-p {
                        display: inline-block;
                        margin-left: 15px;
                        flex: 1;
                        .title {
                            height: 31px;
                            line-height: 20px;
                            font-size: 20px;
                            font-weight: bold;
                        }
                        .text {
                            width: 100%;
                            font-size: 16px;
                            color: #646464;
                        }
                    }
                }
            }
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
